module.exports = __webpack_public_path__ + "static/front-44ae9ee33fd7ab45972bf11544a3721b.jpg";